import { ISize } from '@pressreader/geometry';

const maxMobileScreenWidth = 480;

export function getScreenSize(): ISize {
    return { width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, height: window.innerHeight };
}

/**
 * Width of the layout viewport (the initial containing block) in CSS pixels.
 *
 * Unlike `window.innerWidth`, which tracks the visual viewport and inflates when
 * mobile Safari zooms out to fit content that overflows the layout, this value
 * stays equal to the width blocks actually lay out against.
 */
export function getLayoutViewportWidth(): number {
    return document.documentElement.clientWidth;
}

export function isMobileScreen() {
    const size = getScreenSize();
    return size.width < maxMobileScreenWidth || size.height < maxMobileScreenWidth;
}
